export const mutations = {
  SET_CLIENT_CLAIMS(state, payload) {
    state.claimCenter.myClaims.tableData = payload.claims;
  },
  SET_DATA_TYPE(state, payload) {
    state.claimCenter.myClaims.typeOfData = payload;
  },
};
